import types from './types'

export default {
  setSelectedRoom ({commit}, roomId) {
    commit(types.mutations.SET_SELECTED_ROOM, roomId);
  },
  [types.actions.SELECT_DATE] ({commit}, date) {
    commit(types.mutations.SET_SELECTED_DATE, date);
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js